import { useState } from 'react';
import { offerConditions, type OfferTerms as Terms } from '../api';

/**
 * The conditions attached to an offer, and its small print.
 *
 * Separate from the sale list because the question "is there a catch" applies
 * to deals with no product list at all — a clipped coupon, a percentage off.
 *
 * The terms render verbatim: paraphrasing a legal text would be a claim, and
 * the people who need it need all of it. Collapsed by default, because nobody
 * reads two hundred words before deciding whether the trip is worth it.
 */
export function OfferTermsPanel({ offer }: { offer: Terms }) {
  const [open, setOpen] = useState(false);
  const conditions = offerConditions(offer);
  if (!conditions.length && !offer.terms) return null;

  return (
    <div className="offer-terms">
      {conditions.length > 0 && (
        <ul className="offer-conditions">
          {conditions.map((c) => (
            <li key={c}>{c}</li>
          ))}
        </ul>
      )}
      {offer.terms && (
        <>
          <button className="offer-terms-toggle" aria-expanded={open} onClick={() => setOpen(!open)}>
            {open ? 'Hide terms' : 'View terms'}
          </button>
          {open && <p className="offer-terms-body">{offer.terms}</p>}
        </>
      )}
    </div>
  );
}
